const Vue = require('vue');
const { catchImport } = require('@H/utils');
const { PLACES_API_KEY } = require('./config');

if (window.ENV.APP_STAGE === 'production') {
    const Sentry = require('@sentry/browser');
    const Integrations = require('@sentry/integrations');

    Sentry.init({
        dsn: 'https://1bfefc484fc2406cba2f2819d54b887a@sentry.io/1471477',
        integrations: [
            new Integrations.Vue({
                Vue,
                attachProps: true,
            }),
        ],
    });
}

window._ = {
    get: require('lodash/get')
};
window.Popper = require('popper.js').default;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (err) {
    catchImport(err);
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error(
        'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token'
    );
}

/**
 * The sandbox variable is environment specific and is used for turning certain features on/off
 * such as displaying the callback URL field on the login form
 */
window.sandbox_mode = document.head.querySelector('meta[name="sandbox_mode"]')
    .content
    ? true
    : false;

window.go_to_smartcharts = document.head.querySelector(
    'meta[name="go_to_smartcharts"]'
).content
    ? true
    : false;

// The URL to go to once login is complete
window.callbackUrl = document.head.querySelector('meta[name="post_login_url"]').content;

// The URL to find pages such as terms
window.lmsUrl = document.head.querySelector('meta[name="lms_url"]').content;

window.appName = document.head.querySelector('meta[name="app_name"]').content;

window.isSmartCharts = !!document.head.querySelector('meta[name="is_smartcharts"]').content;

/**
 * Pull in querystring which works the same as PHPs http_build_query
 * querystring.stringify({foo: 'bar'}) converts an object into a valid query string
 */
window.querystring = require('querystring');

/**
 * Polyfill for ES6 Promises - Automatically polyfills the global environment
 */

require('es6-promise/auto');

/**
 * Add Maps API script
 */

let script = document.createElement('script');
script.setAttribute('type', 'text/javascript');
script.setAttribute(
    'src',
    `https://maps.googleapis.com/maps/api/js?key=${PLACES_API_KEY}&libraries=places`
);
document.body.insertAdjacentElement('beforeend', script);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js